module.exports = __webpack_public_path__ + "img/buy_credits.d099fde9.svg";